import React from "react";
import PropTypes from "prop-types";
import { Modal, Spinner } from "react-bootstrap";
import { isBooleanTrue, isStringNotEmpty } from "../../utils/objectUtils";

const LoadingWrapper = ({ isLoading, message, dark = false, fullPage = false, children }) => {
    if (isBooleanTrue(isLoading)) {
        if (isBooleanTrue(fullPage)) {
            return (
                <>
                    <Modal bsPrefix="loading-modal" show={isLoading} centered backdrop="static" size="sm" contentClassName={isStringNotEmpty(message) ? "" : "bg-transparent border-0"} fullscreen>
                        <Modal.Body className="text-center d-flex flex-column align-items-center justify-content-center">
                            <div className="bounce-loader-white text-white"></div>
                            {isStringNotEmpty(message) ? (
                                <div className="mt-3">{message}</div>
                            ) : null}
                            {children}
                        </Modal.Body>
                    </Modal >
                </>
            );
        }

        if (isStringNotEmpty(message)) {
            return (
                <>
                    <div className="mt-3" style={{
                        backgroundColor: '#ffffff',
                        color: '#000000',
                        position: 'fixed',
                        zIndex: 20000,
                        opacity: 1,
                        width: 300,
                        padding: '10px',
                        borderRadius: '10px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,30%)'
                    }}>{message}</div>
                    <div className="spinner-overlay" id="loading" style={{ backgroundColor: '#000000', position: 'fixed' }}>
                        <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                            <Spinner animation="border" role="status" style={{ color: '#ffffff' }} />
                        </div>
                    </div>
                    {children}
                </>
            );
        } else {
            if (isBooleanTrue(dark)) {
                return (
                    <>
                        <div className="spinner-overlay" id="loading" style={{ backgroundColor: '#000000', position: 'fixed' }}>
                            <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                                <Spinner animation="border" role="status" style={{ color: '#ffffff' }} />
                            </div>
                        </div>
                        {children}
                    </>
                );
            } else {
                return (
                    <>
                        <div className="spinner-overlay" id="loading">
                            <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                                <Spinner animation="border" role="status" />
                            </div>
                        </div>
                        {children}
                    </>
                );
            }
        }
    } else {
        return (
            <>
                {children}
            </>
        )
    }
};

LoadingWrapper.propTypes = {
    isLoading: PropTypes.bool
};

export default LoadingWrapper;